var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseCircleGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5.813a9.188 9.188 0 10.001 18.376A9.188 9.188 0 009.5.812zm3.392 12.677l-1.353-.006-2.039-2.43-2.036 2.428-1.356.006a.163.163 0 01-.164-.164.17.17 0 01.039-.106l2.668-3.179-2.668-3.177a.165.165 0 01.125-.27l1.356.006L9.5 9.028 11.536 6.6l1.354-.006c.09 0 .164.071.164.164a.17.17 0 01-.039.106l-2.664 3.177 2.666 3.179a.165.165 0 01-.125.27z",
    fill: "#595959"
  })));
}

export default __webpack_public_path__ + "./fonts/close-circle-gray.154b8291b18ba668e1317ebbdc31835c.svg";
export { SvgCloseCircleGray as ReactComponent };